import { Button, Flex, Text } from "@chakra-ui/react";
import Illustration from "./illustration";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import gsap from 'gsap'
import { useTranslation } from "../../i18n/LanguageContext";

export default function Baseline() {

  const container = useRef();
  const { t } = useTranslation();

  useGSAP(
    () => {
      gsap.from(".slide-in-1, .slide-in-2, .slide-in-3", {
        x: -200,
        opacity: '0',
        duration: 0.5,
        ease: "power2.inOut",
        stagger: 0.1
      });
    },
    { scope: container }
  );

  const titleParts = t("hero.title").split("\n");

  return (
    <Flex
      as="section"
      aria-label={t("hero.aria")}
      backgroundColor={"background.coral"}
      padding={"30px"}
      borderRadius={"20px"}
      minHeight={"calc(100vh - 200px)"}
      height={"fit-content"}
      gap={["30px", "70px"]}
      width={"100%"}
      alignItems={["center"]}
      justifyContent={"center"}
      border="1px solid"
      borderColor={"divider.coral"}
      ref={container}
      flexDirection={["column","row"]}
    >
      <Flex
        flexDirection={"column"}
        flexShrink={"0"}
      >
        <Text
          as="h1"
          maxW={"520px"}
          fontSize={["30px", "30px", "40px"]}
          fontWeight={"600"}
          lineHeight={["40px", "40px", "55px"]}
          className="slide-in-1"
        >{titleParts[0]}<br />{titleParts[1]}</Text>
        <Text
          as="p"
          color={"text.medium.grey"}
          maxW={"400px"}
          fontSize={"20px"}
          lineHeight={"30px"}
          className="slide-in-2"
          mt={1}
        >{t("hero.subtitle")}</Text>
        <Link
          to={process.env.REACT_APP_BIBLIONA_URL}
          className="slide-in-3"
          target='_blank'
          aria-label={t("hero.signInAria")}
        >
          <Button
            variant={"coralFill"}
            width={"fit-content"}
            minW={"100px"}
            mt={3}
          >{t("hero.signIn")}</Button>
        </Link>
      </Flex>
      <Illustration />
    </Flex>
  );
}
